import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "6d4dfe05-b374-403f-ac99-07f2930d946f",
    content: "The results of two simulations with the same<br>input parameter are always the same.",
    options: {},
  },
  {
    id: "9d0edf67-1891-480b-91ca-6b49f9efd9e0",
    content: "The results are just with certain<br>probability physically correct.",
    options: {},
  },
];

export const task: Task = {
  id: "bfeb4496-8f1a-4164-866b-7f642ee35459",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["9d0edf67-1891-480b-91ca-6b49f9efd9e0"],
};
